import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { passwordRequirements } from "../../mocks";
import { CheckIcon, MenuCloseIcon } from "../../../../components/storybook";
import { transform } from "lodash";



export function PasswordRequirementsList({ password, userData }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F2F2F2",
        p: "10px 12px",
        borderRadius: 2,
      }}
    >
      {passwordRequirements.map((requirement, index) => {
        const isValid = requirement.isValid(password, userData);

        const getStatusIcon = () => {
          if (isValid === null) {
            return (
              <Box
                sx={{
                  width: 4,
                  height: 4,
                  borderRadius: "50%",
                  backgroundColor: "#636363",
                }}
              />
            );
          }

          return isValid ? (
            <CheckIcon color="#5CB860" size={11} />
          ) : (
            <MenuCloseIcon color="#E01E36" size={9} sx={{ pl: '0.5px' }} />
          );
        };

        const getLabelColor = () => {
          if (isValid === null) return "#969EA9";
          return isValid ? "#75B873" : "#E01E36";
        };

        return (
          <Stack
            key={index}
            direction="row"
            alignItems="center"
            spacing={1}
            pl={0.75}
          >
            {getStatusIcon()}
            <Typography
              variant="body2"
              sx={{
                fontSize: 11,
                lineHeight: "19px",
                fontFamily: "Roboto",
                color: getLabelColor(),
              }}
            >
              {requirement.label}
            </Typography>
          </Stack>
        );
      })}
    </Box>
  );
}
